export const nameof = <T>(name: keyof T): string => name as string;

export const shortKey = (): string => crypto.randomUUID().substring(0, 6);
